import MuiTab from '@mui/material/Tab';

import { getTypographyStyles, styled } from 'helpers';

import { TabProps } from './';

export const Tab = styled(MuiTab)<TabProps>`
  ${({ theme }) => getTypographyStyles('h6', theme)}
  color: ${({ theme }) => theme.palette.blueGrey.A600};
  margin-right: ${({ theme }) => theme.spacing(5)};
  min-height: 0;
  min-width: 0;
  opacity: 1;
  padding: 0;
  padding-bottom: ${({ theme }) => theme.spacing(1)};
  &:hover {
    color: ${({ theme }) => theme.palette.text.primary};
  }
  &.Mui-selected {
    color: ${({ theme }) => theme.palette.text.primary};
  }
`;
Tab.displayName = 'Tab';

export default Tab;
